import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {ButtonModule} from '@aztrix/components/button';
import {IconsModule} from '@aztrix/icons';
import {TranslatePipe} from '@aztrix/translate';

import {ChipsEditComponent} from './chips-edit.component';
import {DisableSpecialFileCharactersDirective} from './disable-special-file-characters.directive';

@NgModule({
  declarations: [ChipsEditComponent, DisableSpecialFileCharactersDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    ScrollingModule,
    IconsModule,
    TranslatePipe,
    MatChipsModule,
    ButtonModule,
  ],
  exports: [ChipsEditComponent],
})
export class ChipsEditModule {}
